// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__3BYJo","has_error":"styles_has_error__2Arq9"};